import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { initSentry, Sentry } from "./lib/sentry";
import { initSync } from "./lib/sync";
import { shouldReloadForChunkError } from "./lib/lazyWithReload";

// Backstop for Vite's module-preload failures after a deploy (stale chunk) —
// reload once to fetch the fresh build instead of surfacing a hard error.
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  if (shouldReloadForChunkError()) window.location.reload();
});

// Initialize error monitoring off the critical path — the ErrorBoundary below
// still renders from first paint; this just moves Sentry's setup out of the
// initial render so it doesn't delay interactivity (perf sweep A3). No-op
// without a DSN.
const startSentry = () => initSentry();
if (typeof requestIdleCallback !== "undefined") requestIdleCallback(startSentry);
else setTimeout(startSentry, 0);

// Start the offline sync outbox: replay queued writes on reconnect / startup.
initSync();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="site center">
          <p className="muted">Something went wrong. Please refresh the page.</p>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
